// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f4819c8a","15":"3c09c52c","41":"3052b630","83":"4c15a6d9","176":"40d5bb22","214":"8bdd43e0","218":"42927d52","456":"cf5408a9","461":"b5d6ed81","488":"5d7af664","684":"1648b208","892":"f87405a8","899":"9046a261","920":"e86310e9","936":"6e001f83"}[chunkId] + ".chunk.js";
};